import { render, staticRenderFns } from "./i-array-editor.vue?vue&type=template&id=03bde29e&scoped=true&"
import script from "./i-array-editor.vue?vue&type=script&lang=js&"
export * from "./i-array-editor.vue?vue&type=script&lang=js&"
import style0 from "./i-array-editor.vue?vue&type=style&index=0&id=03bde29e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bde29e",
  null
  
)

export default component.exports